<template>
  <v-card class="search-header-card" color="transparent" elevation="0" rounded="lg" width="100%">
    <!-- Filtros Principales -->
    <v-row align="center" justify="center" no-gutters>
      <!-- UNIDAD DE NEGOCIOS -->
      <v-col cols="12" sm="6" md="auto" lg="auto" xl="auto" class="px-1">
        <v-autocomplete v-model="business_selected" :items="itemsBussines" label="Unidad de negocio" color="primary"
          item-color="primary" @change="handleBusinessChange" outlined dense hide-details class="filter-input">
          <template v-slot:prepend-inner>
            <v-icon color="primary" size="20">mdi-office-building-outline</v-icon>
          </template>
        </v-autocomplete>
      </v-col>

      <!-- LOCATION -->
      <v-col v-show="show_location" cols="12" sm="6" md="auto" lg="auto" xl="auto" class="px-1">
        <v-autocomplete v-model="location_selected" :items="itemsLocations2" @change="handleLocationChange"
          return-object color="primary" item-color="primary" label="Sucursal" outlined dense hide-details
          class="filter-input">
          <template v-slot:prepend-inner>
            <v-icon color="primary" size="20">mdi-map-marker-outline</v-icon>
          </template>
        </v-autocomplete>
      </v-col>

      <!-- RANGO -->
      <v-col v-show="show_weeks" cols="12" sm="6" md="auto" lg="auto" xl="auto" class="px-1">
        <v-autocomplete v-model="rangeSelected" :items="rangeTime" label="Rango de tiempo" color="primary"
          item-color="primary" outlined dense hide-details @change="handleRangeChange" class="filter-input">
          <template v-slot:prepend-inner>
            <v-icon color="primary" size="20">mdi-calendar-range</v-icon>
          </template>
        </v-autocomplete>
      </v-col>

      <!-- FECHAS PERSONALIZADAS -->
      <v-col v-show="rangeSelected == '7'" cols="12" md="auto" class="px-1">
        <div class="date-range-wrapper">
          <!-- Fecha desde -->
          <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto" max-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateFormatDMY" label="Desde" readonly v-bind="attrs" v-on="on"
                outlined dense hide-details color="primary" class="date-input">
                <template v-slot:prepend-inner>
                  <v-icon color="primary" size="18">mdi-calendar-start</v-icon>
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="date" @input="menu = false" color="primary" header-color="primary"
              show-current locale="es"></v-date-picker>
          </v-menu>

          <!-- Separador -->
          <v-icon size="16" color="grey lighten-1" class="date-separator">mdi-arrow-right</v-icon>

          <!-- Fecha hasta -->
          <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto" max-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="date2FormatDMY" label="Hasta" readonly v-bind="attrs" v-on="on"
                outlined dense hide-details color="primary" class="date-input">
                <template v-slot:prepend-inner>
                  <v-icon color="primary" size="18">mdi-calendar-end</v-icon>
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="date2" @input="menu2 = false" color="primary" header-color="primary"
              show-current locale="es"></v-date-picker>
          </v-menu>
        </div>
      </v-col>

      <!-- BOTÓN ACTUALIZAR -->
      <v-col v-if="show_refresh" cols="12" sm="6" md="3" lg="auto" xl="auto"
        class="px-1 d-flex align-center" align="center" justify="center">
        <v-btn color="primary" @click="updateData" :loading="loading" class="update-btn" rounded elevation="2"
          :block="$vuetify.breakpoint.xs">
          <v-icon left size="20">mdi-refresh</v-icon>
          <span class="font-weight-medium">Actualizar</span>
        </v-btn>
      </v-col>
    </v-row>

  </v-card>
</template>

<script>
import moment from "moment";

export default {
  name: "SearchHeaderPO",

  data() {
    return {
      menu: false,
      menu2: false,
      itemsBussines: [],
      bussinessAccount: [],
      itemsLocations: [],
      itemsLocations2: [],
      rangeTime: [
        { text: "Hoy", value: "1" },
        { text: "Últimos 7 días", value: "3" },
        { text: "Últimos 30 días", value: "4" },
        { text: "Últimos 60 días", value: "8" },
        { text: "Últimos 90 días", value: "9" },
        { text: "Este año", value: "6" },
        { text: "Personalizado", value: "7" },
      ],
      loading: false,
      isInitialized: false,
      updateDataTimeout: null,
      isUpdatingData: false,
    };
  },

  props: {
    show_location: {
      type: Boolean,
      default: true,
    },
    show_weeks: {
      type: Boolean,
      default: true,
    },
    show_refresh: {
      type: Boolean,
      default: true,
    },
    selected_week: {
      type: Number,
      default: 4,
    },
    show_category: {
      type: Boolean,
      default: false,
    },
    show_diary_book_type: {
      type: Boolean,
      default: false,
    },
    showAdditionalFilter: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    business_selected: {
      get() {
        return this.$store.state.app.filters.business;
      },
      set(value) {
        this.$store.commit("setBusiness", value);
      },
    },

    location_selected: {
      get() {
        return this.$store.state.app.filters.location;
      },
      set(value) {
        if (this.isValidLocationValue(value)) {
          this.$store.commit("setLocation", value);
        }
      },
    },

    department_selected: {
      get() {
        return this.$store.state.app.filters.department_id;
      },
      set(value) {
        this.$store.commit("setDepartment", value);
      },
    },

    rangeSelected: {
      get() {
        return this.$store.state.app.rangeSelected;
      },
      set(value) {
        this.$store.commit("setRangeSelected", value);
      },
    },

    date: {
      get() {
        return this.$store.state.app.date;
      },
      set(value) {
        if (value && moment(value).isValid()) {
          this.$store.commit("setDateStart", value);
        }
      },
    },

    date2: {
      get() {
        return this.$store.state.app.date2;
      },
      set(value) {
        if (value && moment(value).isValid()) {
          this.$store.commit("setDateEnd", value);
        }
      },
    },

    dateFormatDMY() {
      const storeDate = this.$store.state.app.date;
      const currentDate = storeDate || moment().startOf("month").format("YYYY-MM-DD");
      return moment(currentDate).format("DD/MM/YYYY");
    },

    date2FormatDMY() {
      const storeDate2 = this.$store.state.app.date2;
      const currentDate2 = storeDate2 || moment().endOf("month").format("YYYY-MM-DD");
      return moment(currentDate2).format("DD/MM/YYYY");
    },

  },

  methods: {
    isValidLocationValue(value) {
      if (value === null || value === undefined) return false;
      if (typeof value === "number" && value === 0) return true;
      if (typeof value === "object" && value.value !== undefined) return true;
      return typeof value === "number" && value > 0;
    },

    ensureBusinessSelected() {
      if (this.business_selected == null || this.business_selected === "") {
        const units = this.$store.state.auth.bussines_units;
        this.$store.commit("setBusiness", units.length > 0 ? units[0].value : 0);
      }
    },

    handleBusinessChange() {
      this.updateLocationsForBusiness();
      this.updateData();
    },

    handleLocationChange() {
      this.updateData();
    },

    handleRangeChange(selectedRange) {
      this.updateRange(selectedRange);
    },

    syncWithStore() {
      const storeDate = this.$store.state.app.date;
      const currentMonth = moment().format("YYYY-MM");
      const storeMonth = storeDate ? moment(storeDate).format("YYYY-MM") : null;

      if (
        this.$store.state.app.rangeSelected === "4" &&
        storeMonth &&
        storeMonth !== currentMonth
      ) {
        this.$store.dispatch("resetToCurrentMonth");
      } else {
        this.$store.dispatch("initializeDates");
      }

      this.isInitialized = true;
    },

    updateLocationsForBusiness() {
      if (
        !this.$store.state.auth.locations ||
        this.$store.state.auth.locations.length === 0
      ) {
        setTimeout(() => {
          if (
            this.$store.state.auth.locations &&
            this.$store.state.auth.locations.length > 0
          ) {
            this.updateLocationsForBusiness();
          }
        }, 500);
        return;
      }

      this.itemsLocations2 = [];

      if (this.business_selected && this.business_selected != 0) {
        this.itemsLocations2 = this.updateCombo(
          this.itemsLocations,
          this.itemsLocations2,
          this.business_selected,
          "location"
        );
      } else {
        this.itemsLocations2 = [...this.itemsLocations];
        this.itemsLocations2.unshift({ text: "Todas", value: 0 });
      }

      this.validateLocationSelection();
    },

    validateLocationSelection() {
      if (this.location_selected) {
        const selectedValue =
          typeof this.location_selected === "object"
            ? this.location_selected.value
            : this.location_selected;

        const locationExists = this.itemsLocations2.find(
          (loc) => loc.value === selectedValue
        );

        if (!locationExists && selectedValue !== 0) {
          // La sucursal anterior no existe en la nueva unidad → resetear a "Todas"
          this.location_selected = { text: "Todas", value: 0 };
        }
      } else if (!this.location_selected && this.itemsLocations2.length > 0) {
        this.location_selected = this.itemsLocations2[0];
      }
    },

    updateRange(item) {
      let dateStart, dateEnd;
      const today = moment().format("YYYY-MM-DD");

      switch (item) {
        case "1": // Hoy
          dateStart = dateEnd = today;
          break;
        case "3": // Últimos 7 días
          dateStart = moment().subtract(7, "days").format("YYYY-MM-DD");
          dateEnd = today;
          break;
        case "4": // Últimos 30 días
          dateStart = moment().subtract(30, "days").format("YYYY-MM-DD");
          dateEnd = today;
          break;
        case "8": // Últimos 60 días
          dateStart = moment().subtract(60, "days").format("YYYY-MM-DD");
          dateEnd = today;
          break;
        case "9": // Últimos 90 días
          dateStart = moment().subtract(90, "days").format("YYYY-MM-DD");
          dateEnd = today;
          break;
        case "6": // Este año
          dateStart = moment().startOf("year").format("YYYY-MM-DD");
          dateEnd = moment().endOf("year").format("YYYY-MM-DD");
          break;
        case "7": // Personalizado
          return;
        default:
          return;
      }

      if (dateStart && dateEnd) {
        this.$store.commit("setDateRange", {
          dateStart: dateStart,
          dateEnd: dateEnd,
        });

        this.updateData();
      }
    },

    async updateData() {
      if (this.updateDataTimeout) {
        clearTimeout(this.updateDataTimeout);
      }

      if (this.isUpdatingData) {
        return;
      }

      this.updateDataTimeout = setTimeout(async () => {
        try {
          this.isUpdatingData = true;

          this.ensureBusinessSelected();

          const hasValidLocationSelected =
            this.location_selected &&
            (typeof this.location_selected === "object"
              ? this.location_selected.value !== undefined
              : this.location_selected !== 0);

          if (!hasValidLocationSelected) {
            this.location_selected = { text: "Todas", value: 0 };
          }

          if (this.department_selected === null) {
            this.department_selected = 0;
          }

          const actualDateStart = this.$store.state.app.date;
          const actualDateEnd = this.$store.state.app.date2;

          const selectedLocationValue =
            typeof this.location_selected === "object"
              ? this.location_selected.value
              : this.location_selected;

          // Si se seleccionó una sucursal específica la usamos tal cual.
          // Si es "Todas" (0), enviamos los IDs accesibles para ese negocio
          // (itemsLocations2 ya viene filtrado por unidad + permisos del usuario)
          // para que el backend nunca devuelva datos de sucursales a las que el
          // usuario no tiene acceso.
          let locationToEmit;
          if (selectedLocationValue && selectedLocationValue !== 0) {
            locationToEmit = selectedLocationValue;
          } else {
            const accessibleIds = this.itemsLocations2
              .filter(loc => loc.value !== 0)
              .map(loc => loc.value)
              .join(",");
            locationToEmit = accessibleIds || null;
          }

          const filtersToEmit = {
            business: this.business_selected,
            businessData: this.business_selected,
            location: locationToEmit,
            dateStart: actualDateStart,
            dateEnd: actualDateEnd,
            rangeSelected: this.rangeSelected,
          };

          // Importante: NO incluir `location` en setFilters — ya está manejado por
          // setLocation con formato {text, value}, y sobrescribirlo aquí con el
          // primitivo (id o "5,6,7") rompe el v-model del autocomplete con return-object.
          this.$store.commit("setFilters", {
            business: this.business_selected,
            dateStart: actualDateStart,
            dateEnd: actualDateEnd,
            rangeSelected: this.rangeSelected,
          });
          this.$emit("dataFilters", filtersToEmit);
        } catch (error) {
          console.error("Error in updateData:", error);
        } finally {
          this.isUpdatingData = false;
        }
      }, 300);
    },

    async getData() {
      try {
        this.loading = true;

        // Unidades de negocio desde el store (sin llamada a la API)
        this.itemsBussines = [
          { text: "Todas", value: 0 },
          ...this.$store.state.auth.bussines_units,
        ];

        // Validar que el rango en el store sea uno de los valores válidos
        const currentRange = this.$store.state.app.rangeSelected;
        const isValidRange = this.rangeTime.some(el => el.value === currentRange);
        const fallbackRange = this.rangeTime.find(el => el.value == this.selected_week.toString())?.value || "4";

        if (!this.$store.state.app._isInitialized || !isValidRange) {
          this.$store.commit("setRangeSelected", fallbackRange);
          this.updateRange(fallbackRange);
        }

        // Garantizar unidad seleccionada
        this.ensureBusinessSelected();

        // Locations desde el store (sin llamada a la API)
        this.itemsLocations = [...(this.$store.state.auth.locations || [])];

        this.updateLocationsForBusiness();

        // Safety-net: si después de todo location sigue nula, forzar "Todas"
        if (!this.location_selected) {
          this.location_selected = { text: "Todas", value: 0 };
        }

        this.syncWithStore();
        this.updateData();
      } catch (error) {
        console.error("Error in getData:", error);
      } finally {
        this.loading = false;
      }
    },

    updateCombo(itemsOrigen, itemsDestino, condicion, combo) {
      if (!itemsOrigen || !Array.isArray(itemsOrigen) || itemsOrigen.length === 0) {
        itemsDestino.splice(0, itemsDestino.length);
        itemsDestino.unshift({ text: "Todas", value: 0 });
        return itemsDestino;
      }

      itemsDestino.splice(0, itemsDestino.length);

      for (let item of itemsOrigen) {
        if (item.bus_id === condicion) {
          itemsDestino.push({
            value: item.value,
            text: item.text,
            routes: item.routes,
          });
        }
      }
      itemsDestino.unshift({ text: "Todas", value: 0 });

      const hasValidSelection =
        this.location_selected &&
        (typeof this.location_selected === "object" ||
          (typeof this.location_selected === "number" && this.location_selected !== 0));

      if (!hasValidSelection) {
        this.location_selected = itemsDestino[0];
      } else {
        const currentSelectionExists = itemsDestino.find((item) => {
          if (typeof this.location_selected === "object") {
            return item.value === this.location_selected.value;
          } else {
            return item.value === this.location_selected;
          }
        });

        if (!currentSelectionExists && this.location_selected.value !== 0) {
          // La sucursal seleccionada no pertenece a la nueva unidad → resetear a "Todas"
          this.location_selected = itemsDestino[0];
        }
      }

      return itemsDestino;
    },

  },

  beforeDestroy() {
    if (this.updateDataTimeout) {
      clearTimeout(this.updateDataTimeout);
    }
  },

  watch: {
    date(newVal, oldVal) {
      if (newVal !== oldVal && moment(newVal).isValid()) {
        if (this.rangeSelected == "7") {
          this.updateData();
        }
      }
    },

    date2(newVal, oldVal) {
      if (newVal !== oldVal && moment(newVal).isValid()) {
        if (this.rangeSelected == "7") {
          this.updateData();
        }
      }
    },

    rangeSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal != "7") {
          this.updateRange(newVal);
        }
      }
    },

    business_selected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateLocationsForBusiness();
      }
    },

    "$store.state.auth.locations": {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          // Poblar itemsLocations ANTES de filtrar para no perder la selección guardada en el store
          this.itemsLocations = [...newVal];
          this.updateLocationsForBusiness();
          // Safety-net: si location sigue nula después de filtrar, forzar "Todas"
          if (!this.location_selected) {
            this.location_selected = { text: "Todas", value: 0 };
          }
        }
      },
      immediate: true,
    },

    "$store.state.auth.bussines_units": {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.itemsBussines = [{ text: "Todas", value: 0 }, ...newVal];
          this.ensureBusinessSelected();
        }
      },
      immediate: true,
    },

  },

  async created() {
    await this.getData();
  },

  mounted() {
    if (this.showAdditionalFilter) {
      this.showAdditionalFilters = true;
    }
    if (this.$store.state.auth.locations && this.$store.state.auth.locations.length > 0) {
      this.updateLocationsForBusiness();
    }
  },
};
</script>

<style scoped>
.search-header-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.filter-input {
  transition: all 0.2s ease;
  width: 100%;
  max-width: 100%;
}

.filter-input >>> .v-input__control {
  min-height: 40px;
}

.filter-input >>> .v-input__slot {
  min-height: 40px !important;
  transition: all 0.2s ease;
}

.filter-input:hover >>> .v-input__slot {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.filter-input >>> .v-input__prepend-inner {
  margin-top: 8px;
  margin-right: 8px;
}

.update-btn {
  text-transform: none;
  letter-spacing: 0.5px;
  min-width: 140px;
  max-width: 180px;
  height: 40px !important;
  transition: all 0.2s ease;
}

.update-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
}

.v-divider {
  opacity: 0.5;
}

.v-icon {
  transition: all 0.2s ease;
}

.v-input--is-focused .v-icon {
  transform: scale(1.05);
}

.date-range-wrapper {
  display: flex;
  align-items: center;
  gap: 0;
  background: rgba(25, 118, 210, 0.04);
  border: 1px solid rgba(25, 118, 210, 0.25);
  border-radius: 8px;
  padding: 2px 6px;
}

.date-input {
  min-width: 140px;
  max-width: 160px;
}

.date-input >>> .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  min-height: 40px !important;
}

.date-input >>> fieldset {
  border: none !important;
}

.date-input >>> .v-input__prepend-inner {
  margin-top: 8px;
  margin-right: 4px;
}

.date-separator {
  flex-shrink: 0;
  margin: 0 4px;
}

@media (max-width: 599px) {
  .search-header-card {
    padding: 12px !important;
  }

  .filter-input {
    width: 100%;
  }

  .update-btn {
    width: 100%;
    min-width: 100%;
  }

  .v-col.py-1 {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
}

@media (min-width: 600px) and (max-width: 959px) {
  .search-header-card {
    padding: 16px !important;
  }
}

@media (min-width: 960px) {
  .filter-input {
    min-width: 220px;
    max-width: 320px;
    flex: 1 1 auto;
  }
}

@media (min-width: 1264px) {
  .filter-input {
    min-width: 280px;
    max-width: 350px;
  }
}

@media (min-width: 1904px) {
  .filter-input {
    min-width: 300px;
    max-width: 400px;
  }
}

.v-input {
  font-size: 14px;
}

.filter-input >>> .v-label {
  font-size: 13px;
}

.filter-input >>> .v-label--active {
  font-size: 12px;
}

.filter-input >>> .v-select__selections {
  padding-top: 0;
  padding-bottom: 0;
}

.filter-input >>> .v-select__selection {
  font-size: 14px;
}
</style>
